import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/sell-used-car-dubai/components/ClientFormWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ui/Accordion/Accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ui/buttons/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/homes-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/innovation-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/jobs-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/ravo-logo.png");
